import { render, staticRenderFns } from "./EditMatchingOrder.vue?vue&type=template&id=8779bd68&scoped=true"
import script from "./EditMatchingOrder.vue?vue&type=script&lang=js"
export * from "./EditMatchingOrder.vue?vue&type=script&lang=js"
import style0 from "./EditMatchingOrder.vue?vue&type=style&index=0&id=8779bd68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8779bd68",
  null
  
)

export default component.exports